import RegisterPartnerJsSerializer from './-json-api';

const FR_ONLY_ACTIVITY_ATTRS = [
  'business_relationships',
  'business_relationships_other',
  'incoming_transfers_origin',
  'outgoing_transfers_destination',
];

export default class OrganizationSerializer extends RegisterPartnerJsSerializer {
  serialize(snapshot, options) {
    let json = super.serialize(snapshot, options);
    let attributes = json.data?.attributes;

    if (attributes && snapshot.attr('legalCountry') !== 'FR') {
      for (let attr of FR_ONLY_ACTIVITY_ATTRS) {
        delete attributes[attr];
      }
    }

    return json;
  }
}
